const ReviewHome = () => import('@/components/review/components/list.review.components.vue')
 
export default [
  {
    path: '',
    name: 'ReviewHome',
    meta:{
      title: 'review'
    },
    // beforeEnter(to, from, next) {
    //   document.title = to.meta.title
    // },
    component: ReviewHome,
  },
//   {
//     path: ':name',
//     name: 'ReviewList',
//     meta: {
//       title: 'review'
//     },
  
//     component: ReviewList
//   }
]


// WEBPACK FOOTER //
// ./src/router/review.router.js